<template>
  <b-modal :id="newModal.id" v-model="newModal.active" centered
           :title="editing ? $t('affiliates.cpaEditTitle') : $t('affiliates.cpaDetails')"
           size="lg" no-close-on-backdrop hide-footer
           @hide="resetInfoModal"
  >
    <!-- New lifecycle: type first, money second — no dates, no late-days,
         no contract dropdown. Saving activates it and closes the previous one. -->
    <affiliate-cpa-form v-model="newCpa" :editing="editing" :affiliate-name="affiliateName"/>

    <hr/>
    <b-row>
      <b-col cols="6">
        <b-button :disabled="busy" size="sm" block variant="warning" @click="newModal.active=false">
          {{ $t('operations.cancel') }}
        </b-button>
      </b-col>
      <b-col cols="6">
        <b-button
            :disabled="canNotSave || busy"
            size="sm" block variant="primary"
            @click="saveCpa()"
        >
          <b-spinner v-if="busy" small class="mr-25"/>
          {{ editing ? $t('operations.update') : $t('operations.add') }}
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex'
import mixinBase from '@/components/mixin/mixinBase'
import mixinNotifications from '@/components/mixin/mixinNotifications'
import AffiliateCpaForm from '@/components/partial/affiliates/AffiliateCpaForm.vue'

const initCpa = () => ({ type: null, cpa: null, crg: null, startDate: null })

export default {
  name: 'AffiliateCPAModal',
  components: { AffiliateCpaForm },
  mixins: [mixinBase, mixinNotifications],
  props: {
    affiliateId: {
      required: true,
      type: String
    },
    // For the "affiliate will be renamed to…" preview.
    affiliateName: {
      type: String,
      default: ''
    },
  },
  data: () => ({
    newModal: {
      id: 'new-modal',
      content: '',
      active: false
    },
    newCpa: initCpa(),
    busy: false,
  }),
  computed: {
    editing() {
      return this.newCpa?.id != null
    },
    canNotSave() {
      const c = this.newCpa
      if (c.type == null) return true
      if (c.cpa == null || c.cpa === '' || Number(c.cpa) <= 0) return true
      if (c.type === 'CRG' && (c.crg == null || c.crg === '')) return true
      return false
    },
  },
  methods: {
    ...mapActions('affiliate', ['createCpaAffiliate', 'editCpaAffiliate']),
    show(item) {
      if (item != null && item.id != null) {
        // Editing an existing contract: money + start date, type is locked
        // (legacy contracts without a type count as CRG).
        this.newCpa = {
          id: item.id,
          type: item.type || 'CRG',
          cpa: item.cpa,
          crg: item.crg,
          // input[type=date] needs plain yyyy-MM-dd
          startDate: item.startDate ? String(item.startDate).slice(0, 10) : null,
        }
      } else {
        this.newCpa = initCpa()
      }
      this.newModal.active = true
    },
    async saveCpa() {
      let $this = this
      this.busy = true
      const payload = {
        type: this.newCpa.type,
        cpa: Number(this.newCpa.cpa),
        crg: this.newCpa.type === 'CRG' ? Number(this.newCpa.crg) : null,
        // empty = backend defaults to today (create) / keeps the current date (edit)
        startDate: this.newCpa.startDate || null,
      }
      let operation = this.editing ?
          this.editCpaAffiliate({ id: this.affiliateId, cpa: payload, cpaId: this.newCpa.id }) :
          this.createCpaAffiliate({ id: this.affiliateId, cpa: payload })
      operation.then(response => {
        this.showSuccessNotification($this.$t('globalMessages.updateDataSuccess', { system: $this.$t('menu.affiliates') }))
        // Notify the parent (the affiliate detail) with the updated affiliate so
        // its CPA table refreshes, then close the modal.
        this.$emit('saved', response)
        this.newModal.active = false
      })
      operation.catch(err => {
        this.showErrorNotification(this.$t('globalMessages.fetchDataError', { system: this.$t('menu.affiliates') }), this.getErrorDescription(err && err.error ? err.error : err))
      })
      operation.finally(() => {
        $this.busy = false
      })
    },
    resetInfoModal() {
      this.newCpa = initCpa()
    }
  }
}
</script>

<style scoped>
</style>
